import { AiFillHtml5 } from "react-icons/ai";
import { BiLogoVisualStudio } from "react-icons/bi";
import { DiGit, DiJava, DiJavascript, DiOpenshift, DiPython, DiReact } from "react-icons/di";
import {
  FiBox,
  FiCloud,
  FiCpu,
  FiDatabase,
  FiHash,
  FiLayers,
  FiPenTool,
  FiSearch,
  FiServer,
  FiShare2,
  FiShield,
} from "react-icons/fi";
import { IoLogoCss3, IoLogoNodejs } from "react-icons/io";
import {
  SiApachecassandra,
  SiApachekafka,
  SiArduino,
  SiBootstrap,
  SiCouchbase,
  SiCplusplus,
  SiDbeaver,
  SiDocker,
  SiEspressif,
  SiExpress,
  SiFastapi,
  SiFlask,
  SiFramer,
  SiGithub,
  SiGithubactions,
  SiGitlab,
  SiGraphql,
  SiIfttt,
  SiIntellijidea,
  SiJenkins,
  SiJsonwebtokens,
  SiKubernetes,
  SiLinux,
  SiMongodb,
  SiMui,
  SiMysql,
  SiNetlify,
  SiNginx,
  SiOpencv,
  SiPodman,
  SiPostgresql,
  SiPostman,
  SiPrisma,
  SiPycharm,
  SiRaspberrypi,
  SiRazorpay,
  SiRedis,
  SiRedux,
  SiSequelize,
  SiSpring,
  SiSpringboot,
  SiStripe,
  SiSwagger,
  SiTailwindcss,
  SiTypescript,
  SiVercel,
} from "react-icons/si";
import { TbBrandNextjs, TbWebhook } from "react-icons/tb";

// Map of tech/tool name -> icon component. Names not present fall back to a
// generic glyph, so it's always safe to add new tags to the data files.
const ICONS = {
  // Languages
  "C++": SiCplusplus,
  Python: DiPython,
  Java: DiJava,
  JavaScript: DiJavascript,
  TypeScript: SiTypescript,
  SQL: FiDatabase,
  HTML5: AiFillHtml5,
  HTML: AiFillHtml5,
  CSS3: IoLogoCss3,
  CSS: IoLogoCss3,

  // Frontend
  React: DiReact,
  ReactJS: DiReact,
  "React 18": DiReact,
  "React Flow": FiShare2,
  "Next.js": TbBrandNextjs,
  Redux: SiRedux,
  ReduxJS: SiRedux,
  Bootstrap: SiBootstrap,
  "Tailwind CSS": SiTailwindcss,
  MUI: SiMui,
  Framer: SiFramer,

  // Backend
  "Node.js": IoLogoNodejs,
  NodeJS: IoLogoNodejs,
  "Express.js": SiExpress,
  ExpressJS: SiExpress,
  "Spring Boot": SiSpringboot,
  SpringBoot: SiSpringboot,
  Spring: SiSpring,
  Flask: SiFlask,
  FastAPI: SiFastapi,
  Prisma: SiPrisma,
  Sequelize: SiSequelize,
  GraphQL: SiGraphql,

  // Databases
  MongoDB: SiMongodb,
  MySQL: SiMysql,
  PostgreSQL: SiPostgresql,
  Couchbase: SiCouchbase,
  Redis: SiRedis,
  Cassandra: SiApachecassandra,

  // Cloud & DevOps
  AWS: FiCloud,
  "AWS S3": FiCloud,
  Azure: FiCloud,
  "Azure AD SSO": FiCloud,
  Docker: SiDocker,
  Podman: SiPodman,
  Kubernetes: SiKubernetes,
  OpenShift: DiOpenshift,
  Jenkins: SiJenkins,
  "GitLab CI/CD": SiGitlab,
  "GitHub Actions": SiGithubactions,
  nginx: SiNginx,
  Netlify: SiNetlify,
  Vercel: SiVercel,

  // AI / GenAI
  RAG: FiCpu,
  "Vector Search": FiSearch,
  MCP: FiCpu,
  "LLM Integration": FiCpu,
  "Multi-LLM": FiCpu,

  // Concepts
  "System Design": FiLayers,
  Microservices: FiBox,
  "REST APIs": FiServer,
  "RBAC / ABAC": FiShield,
  "OAuth / JWT": SiJsonwebtokens,
  "Apache Kafka": SiApachekafka,
  Kafka: SiApachekafka,
  Swagger: SiSwagger,

  // ML, CV & IoT
  OpenCV: SiOpencv,
  "Machine Learning": FiCpu,
  ESP32: SiEspressif,
  "Raspberry Pi": SiRaspberrypi,
  Arduino: SiArduino,
  IFTTT: SiIfttt,
  Webhooks: TbWebhook,

  // Tools
  Git: DiGit,
  GitHub: SiGithub,
  Linux: SiLinux,
  "VS Code": BiLogoVisualStudio,
  "IntelliJ IDEA": SiIntellijidea,
  PyCharm: SiPycharm,
  DBeaver: SiDbeaver,
  Postman: SiPostman,

  // Payments / misc brands used in project tags
  Stripe: SiStripe,
  Razorpay: SiRazorpay,

  // Generic fallbacks for brands without a dedicated icon in this icon set.
  Heroku: FiCloud,
  "Adobe Illustrator": FiPenTool,
};

export const getTechIcon = (name) => ICONS[name] || FiHash;

export default getTechIcon;
